<template>
  <v-card height="300" width="290" class="ml-4 mt-2 mb-4 pa-4 text-center" :ripple="app.installed" hover :to="app.installed?{name:app.name,params:{alert:app.alert}}:''">
    <v-card-text>
      <v-card flat height="200" :class="{'grey--text':!app.installed}">
        <div>
          <v-badge color="red" dot :value="app.alert">
            <v-img :src="iconURL" :width="app.iconSize" contain class="d-inline-block" :class="{'light-image':!app.installed}"/>
          </v-badge>
        </div>
        <div class="text-h6 mt-4">{{app.title}}</div>
        <div class="text-body-2 mt-4 text-left">{{app.description}}</div>
        <div class="text-right"><v-btn x-small text @click.prevent="$emit('help',app.help)">More info...</v-btn></div>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <template v-if="app.price">
        <template v-if="app.enabled">{{app.price | currency}}/month</template>
        <v-spacer/>
        <template v-if="app.installed">
          <v-btn small plain @click.prevent="showRemove=true"><v-icon class="green--text">mdi-check</v-icon>Installed</v-btn>
        </template>
        <template v-else-if="!app.enabled">
          COMING SOON
        </template>
        <template v-else>
          <v-btn small color="primary" @click.prevent="showAdd=true">Add</v-btn>
        </template>
      </template>
      <template v-else>
        Included with your plan
      </template>
    </v-card-actions>

    <v-dialog v-model="showAdd" persistent max-width="400">
      <v-card>
        <v-card-title>Add application</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Do you want to add the <strong>{{app.title}}</strong> application?
          <div class="mt-4"><strong>{{app.price | currency}}/month (+ GST/HST)</strong></div>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain @click="showAdd=false">Cancel</v-btn>
          <v-btn color="primary" @click="$emit('add');showAdd=false">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRemove" persistent max-width="400">
      <v-card>
        <v-card-title>Remove application</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to remove the <strong>{{app.title}}</strong> application?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="$emit('remove');showRemove=false">Remove</v-btn>
          <v-btn color="primary" @click="showRemove=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
.light-image {
  opacity:0.3;
}
</style>

<script>
export default {
  name: 'AppPick',
  props: {
    app: {type:Object, required:true}
  },
  data() {
    return {
      showAdd: false,
      showRemove: false
    }
  },
  computed: {
    iconURL() {
      return require(`@/assets/${this.app.icon}`);
    }
  }
}
</script>
